import {
  COMBO_CHANNEL,
  WEB_CHANNEL,
  CIRCLES1_CHANNEL,
  CIRCLESLARPU,
  SELF_ACTIVATION_SIM,
  ROOT_CHANNEL,
  PHONE_ONLY_CHANNEL,
  FAMILY_PLAN,
  paths,
  forms,
  CIRCLES10_CHANNEL,
  CIRCLES25_CHANNEL,
  CIRCLES45_CHANNEL,
  CIRCLES55_CHANNEL,
  ESIM_CHANNEL,
  DATA_ONLY_CHANNEL,
  ROADSHOW_CHANNEL,
  CIRCLES3_CHANNEL,
  SIM_ACTIVATION
} from "utils/constants";
import {
  flattenObject,
  pathWithChannel,
  removeSensitiveData
} from "utils/helpers";
import get from "lodash/get";
import map from "lodash/map";

//After adding Analytics files in the folder under src/analytics/type then add it's constant here also
export const ANALYTICS_TYPES = {
  adobe: "AdobeAnalytics",
  cleverTap: "CleverTapAnalytics",
  gtm: "GoogleTagManagerAnalytics"
};

export const ANALYTICS_EVENT_TYPES = {
  TRACK_PAGE: "TRACK_PAGE",
  TRACK_EMAIL_SUBMITTED: "TRACK_EMAIL_SUBMITTED",
  UPDATE_TRANSACTION: "UPDATE_TRANSACTION",
  UPDATE_PAGE_DATA: "UPDATE_PAGE_DATA",
  PUSH_PROFILE: "PUSH_PROFILE",
  PUSH_EVENT: "PUSH_EVENT"
};

export const ANALYTICS_EVENT_STEPS = {
  START: "START",
  FINISH: "FINISH"
};

export const SATELLITE_EVENTS = {
  PURCHASE: "PURCHASE",
  CHARGED: "CHARGED",
  SADPURCHASE: "SADPURCHASE",
  ACTIVATE: "ACTIVATE",
  MYINFO: "MYINFO"
};

// country: { channel: { // put in your params to compare and exclude the flow } }
export const FLOW_EXCLUDE_MAPPING = {
  sg: {
    [CIRCLES1_CHANNEL]: {
      url: [paths.CIRCLES1_SAD] // ignore this url
    }
    // [SELF_ACT_DEL]: {
    //   plan_name: [PLAN_NAME_CIRCLES_ONE] // ignore this plan_name in data
    // }
  }
};

export const ADOBE_EVENTS_MAPPING = {
  planService_api_call_succeeded: {
    category: "PLAN",
    event: "prodView"
  },
  numbers_api_call_succeeded: {
    category: "Number",
    event: "number selection",
    object: "selected_number"
  },
  selectedAddons_requested: {
    true: {
      category: "AddonSelected",
      event: "addons selected",
      object: "addon"
    },
    false: {
      category: "AddonUnselected",
      event: "addons unselected",
      object: "addon"
    }
  },
  PersonalDetailsForm_submitted: {
    event: "personal details",
    transaction: true
  },
  PhonesForm_submitted: {
    event: "phone details",
    transaction: true
  },
  DeliveryInfoForm_submitted: {
    event: "delivery-info"
  },
  order_api_call_succeeded: {
    event: "order-summary",
    transaction: true
  },
  // payment v3, can be removed when payment is fully migrated
  paymentReturn_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.PURCHASE, // This will track purchase event through satellite
    transaction: false, // We should not set digitalData.transaction anymore
    object: "order_product_info"
  },
  // payment v4, new api call for payment
  paymentStatus_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.PURCHASE, // This will track purchase event through satellite
    transaction: false // We should not set digitalData.transaction anymore
  },
  selfActivationDeliveryOrder_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.SADPURCHASE,
    transaction: true
  },
  simActivated_requested: {
    event: "activate",
    trackEvent: SATELLITE_EVENTS.ACTIVATE,
    transaction: false
  },
  activateSimCard_api_call_succeeded: {
    event: "activate",
    trackEvent: SATELLITE_EVENTS.ACTIVATE,
    transaction: true
  },
  MyInfoEvent_requested: {
    event: "click",
    trackEvent: SATELLITE_EVENTS.MYINFO
  }
};

export const ADOBE_PROFILE_MAPPING = {
  email: {
    event: "Email Submitted",
    getData: formValues => {
      return {
        email_address: formValues.email,
        profile_source: "ecomm"
      };
    }
  },
  contact_number: {
    event: "ContactNo Submitted",
    getData: formValues => {
      return {
        contact_number: formValues.contact_number,
        profile_source: "ecomm"
      };
    }
  },
  delivery_hse_blk_tower: {
    event: "Delivery House Block Tower Submitted"
  }
};

export const CLEVERTAP_EVENTS = {
  CHARGED: "Charged",
  PROFILE: "Profile",
  SELECTED_PROMOTION: "selected_promotion",
  PROMOTION_STATUS: "promotion_status",
  SELECTED_NUMBER: "selected_number",
  SELECTED_NUMBER_PORT_IN: "selected_number_port_in",
  GUEST_ORDER_CLICK: "Clicked"
};

export const CLEVERTAP_ALLOWED_EVENTS = [
  "page_visit",
  "selected_promotion",
  "referralCode_api_call_requested",
  "referralCode_api_call_succeeded",
  "promotion_status",
  "verifyIdentity_api_call_succeeded",
  "selectedAddons_requested",
  "selected_number_port_in",
  "selected_number",
  "ecomm_contact_number_entered",
  "ecomm_email_entered",
  "PersonalDetailsForm_submitted",
  "Charged",
  "validateIccId_api_call_succeeded",
  "validateIccId_api_call_requested",
  "guestOrder_api_call_succeeded",
  "selfActivationDeliveryOrder_api_call_succeeded",
  "paymentReturn_api_call_succeeded",
  "paymentStatus_api_call_succeeded",
  "simActivated_requested"
];

const SG_NON_SAD_FLOW_CHANNELS = [
  WEB_CHANNEL,
  PHONE_ONLY_CHANNEL,
  COMBO_CHANNEL,
  ESIM_CHANNEL,
  CIRCLES1_CHANNEL,
  CIRCLES3_CHANNEL,
  CIRCLESLARPU,
  FAMILY_PLAN,
  DATA_ONLY_CHANNEL,
  ROADSHOW_CHANNEL
];

const SG_SAD_FLOW_CHANNELS = [CIRCLES1_CHANNEL, CIRCLESLARPU, FAMILY_PLAN];

const SG_ACTIVATION_FLOW_CHANNELS = [SELF_ACTIVATION_SIM, SIM_ACTIVATION];

const AU_NON_SAD_FLOW_CHANNELS = [
  COMBO_CHANNEL,
  CIRCLES10_CHANNEL,
  CIRCLES25_CHANNEL,
  CIRCLES45_CHANNEL,
  CIRCLES55_CHANNEL
];

export const FACEBOOK_ACTION_TYPE = {
  track: "track"
};

export const FB_EVENTS_NAME = {
  INITIATE_CHECKOUT: "InitiateCheckout",
  ADD_PAYMENT_INFO: "AddPaymentInfo",
  PURCHASE: "Purchase",
  COMPLETE_REGISTRATION: "CompleteRegistration"
};

export const GTM_EVENTS_NAME = {
  ECOMM_EVENT: "ecomm_event",
  CUSTOM_PURCHASE: "custom_purchase",
  ORDER_PURCHASE: "order_purchase",
  PURCHASE: "purchase",
  SADPURCHASE: "sadpurchase",
  ACTIVATE: "activate",
  PROMO_CODE_APPLIED: "promo_code_applied",
  PAGE_VISIT: "page_visit",
  SIM_VERIFICATION: "sim_verification",
  SIM_VERIFICATION_CLICK: "sim_verification_click",
  FIELD_CHANGED: "field_changed",
  NUMBER_SELECTED_PAGE_VIEW: "number_selected_page_view",
  NEW_NUMBER_SELECTED: "new_number_selected",
  EXISTING_NUMBER_ENTERED: "existing_number_entered",
  CURRENT_TELCO: "current_telco_selected",
  PLAN_TYPE: "plan_type_selected",
  NRIC_STATUS: "nric_status_selected",
  PROMO_CODE_ENTERED: "promo_code_entered",
  ADDONS_SELECTED: "addons_selected",
  PERSONAL_DETAIL_SUBMIT: "activation_personal_detail_form_submit"
};

export const FACEBOOK_VALID_COUNTRIES = {
  SG: "sg",
  AU: "au"
};

export const FACEBOOK_EVENTS_MAPPING = {
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  page_visit: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.INITIATE_CHECKOUT],
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PRE_CHECKOUT, channel)
            )
          ]
        },
        {
          events: [FB_EVENTS_NAME.ADD_PAYMENT_INFO],
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ORDER_SUMMARY, channel)
            )
          ]
        }
      ],
      sg: [
        {
          events: [FB_EVENTS_NAME.ADD_PAYMENT_INFO],
          trigger_urls: [`${paths.SELF_ACTIVATION_ORDER_SUMMARY}`]
        }
      ]
    }
  },
  // success_page_visit fires on all :channel/success pages
  success_page_visit: {
    valid_countries: {
      sg: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            `${paths.SUCCESS.replace(ROOT_CHANNEL, SELF_ACTIVATION_SIM)}`
          ]
        }
      ]
    }
  },
  PersonalDetailsForm_submitted: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.COMPLETE_REGISTRATION],
          condition: (data, fbq, action, eventName) => {
            /**
             * facebookpixel event pushed only when second "next" button clicked
             * in /personal-details pages of
             * /:channel/pre-checkout flows
             */
            const eventData = removeSensitiveData(
              flattenData(get(data, "formValues", {}))
            );
            const delivery_slot_id = get(eventData, "delivery_slot_id");
            delivery_slot_id && fbq(action, eventName, data);
          },
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ORDER_SUMMARY, channel)
            )
          ]
        }
      ]
    }
  },
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  paymentReturn_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PAYMENT_RETURN, channel)
            )
          ]
        }
      ],
      sg: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            // for ":channel/sa_delivery" ESIM flows
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`,
            // phoneonly flow
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        }
      ]
    }
  },
  // new payment call for payment v4
  paymentStatus_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PAYMENT_RETURN, channel)
            )
          ]
        }
      ]
    }
  }
};

export const GTM_DATALAYER_FACEBOOK_EVENT_TYPES = {
  CONVERSION: "facebook_conversion_event",
  ACTIVATION: "fb_activation_event"
};

export const GTM_DATALAYER_EVENT_MAPPING = {
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  paymentReturn_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PAYMENT_RETURN, channel)
            )
          ],
          event: GTM_EVENTS_NAME.ECOMM_EVENT
        }
      ],
      jp: [
        {
          trigger_urls: [
            `${paths.PAYMENT_SUCCESS.replace(ROOT_CHANNEL, WEB_CHANNEL)}`
          ],
          event: GTM_EVENTS_NAME.CUSTOM_PURCHASE
        }
      ],
      sg: [
        {
          trigger_urls: [
            ...map(SG_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PAYMENT_RETURN, channel)
            )
          ],
          event: GTM_EVENTS_NAME.PURCHASE
        },
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SUCCESS, channel)
            )
          ],
          event: GTM_EVENTS_NAME.ACTIVATE
        }
      ]
    }
  },
  // new payment call for payment v4
  paymentStatus_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          trigger_urls: [
            ...map(AU_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PAYMENT_RETURN, channel)
            )
          ]
        }
      ]
    }
  },
  selfActivationDeliveryOrder_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SELF_ACTIVATION_SIM_DELIVERY, channel)
            ),
            paths.SELF_ACTIVATION_DELIVERY_SUCCESS
          ],
          event: GTM_EVENTS_NAME.SADPURCHASE
        }
      ]
    }
  },
  simActivated_requested: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SUCCESS, channel)
            )
          ],
          event: GTM_EVENTS_NAME.ACTIVATE
        }
      ]
    }
  },
  order_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_NON_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ORDER_SUMMARY, channel)
            )
          ],
          event: GTM_EVENTS_NAME.ORDER_PURCHASE
        }
      ]
    }
  },
  /* Stop sending events on page load for sad success
  sadPurchaseSuccess_requested: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [`${paths.SELF_ACTIVATION_DELIVERY_SUCCESS}`],
          event: GTM_EVENTS_NAME.SADPURCHASE
        }
      ]
    }
  },
  */
  referralCode_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(
              [...SG_NON_SAD_FLOW_CHANNELS, ...SG_ACTIVATION_FLOW_CHANNELS],
              channel => pathWithChannel(paths.PRE_CHECKOUT, channel)
            ),
            ...map(
              [...SG_NON_SAD_FLOW_CHANNELS, ...SG_ACTIVATION_FLOW_CHANNELS],
              channel => pathWithChannel(paths.ORDER_SUMMARY, channel)
            ),
            ...map(SG_SAD_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SELF_ACTIVATION_SIM_DELIVERY, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SELF_ACTIVATION_PLAN, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PSIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ESIM_VERIFICATION, channel)
            )
          ],
          event: GTM_EVENTS_NAME.PROMO_CODE_APPLIED
        }
      ]
    }
  },
  validateIccId_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PSIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ESIM_VERIFICATION, channel)
            )
          ],
          event: GTM_EVENTS_NAME.SIM_VERIFICATION
        }
      ]
    }
  },
  validateIccId_api_call_requested: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PSIM_VERIFICATION, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.ESIM_VERIFICATION, channel)
            )
          ],
          event: GTM_EVENTS_NAME.SIM_VERIFICATION_CLICK
        }
      ]
    }
  },
  field_changed_number_type: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.NEW_NUMBER, channel)
            ),
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PORT_IN_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.NUMBER_SELECTED_PAGE_VIEW
        }
      ]
    }
  },
  validatePortInNumber_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PORT_IN_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.EXISTING_NUMBER_ENTERED
        }
      ]
    }
  },
  field_changed_telco: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PORT_IN_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.CURRENT_TELCO
        }
      ]
    }
  },
  field_changed_port_in_existing_plan_type: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PORT_IN_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.PLAN_TYPE
        }
      ]
    }
  },
  field_changed_registered_under_own_nric_id: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PORT_IN_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.NRIC_STATUS
        }
      ]
    }
  },
  numbers_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.NEW_NUMBER, channel)
            )
          ],
          event: GTM_EVENTS_NAME.NEW_NUMBER_SELECTED
        }
      ]
    }
  },
  referralCode_api_call_requested: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SELF_ACTIVATION_PLAN, channel)
            )
          ],
          event: GTM_EVENTS_NAME.PROMO_CODE_ENTERED
        }
      ]
    }
  },
  selectedAddons_requested: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.SELF_ACTIVATION_PLAN, channel)
            )
          ],
          event: GTM_EVENTS_NAME.ADDONS_SELECTED
        }
      ]
    }
  },
  PersonalDetailsForm_submitted: {
    valid_countries: {
      sg: [
        {
          trigger_urls: [
            ...map(SG_ACTIVATION_FLOW_CHANNELS, channel =>
              pathWithChannel(paths.PERSONAL_DETAILS, channel)
            )
          ],
          event: GTM_EVENTS_NAME.PERSONAL_DETAIL_SUBMIT
        }
      ]
    }
  }
};

export const GTM_DATALAYER_FACEBOOK_EVENT_MAPPING = {
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  paymentReturn_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          formType: forms.DELIVERY_INFO_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        },
        {
          // for ":channel/sa_delivery" ESIM flows
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`
          ]
        }
      ]
    }
  },
  // new payment call for payment v4
  paymentStatus_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          formType: forms.DELIVERY_INFO_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        },
        {
          // for ":channel/sa_delivery" ESIM flows
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`
          ]
        }
      ]
    }
  },
  // success_page_visit fires on all :channel/success pages
  success_page_visit: {
    valid_countries: {
      sg: [
        {
          // for "self_activation/sim" flow
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.ACTIVATION,
          trigger_urls: [
            `${paths.SUCCESS.replace(ROOT_CHANNEL, SELF_ACTIVATION_SIM)}`
          ]
        }
      ]
    }
  },
  // this API only fires on the page BEFORE order success.
  // therefore the paths here are NOT paths.SUCCESS
  selfActivationDeliveryOrder_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          // for ":channel/sa_delivery" physical SIM flows
          formType: forms.SELF_ACTIVATION_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              FAMILY_PLAN
            )}`,
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              CIRCLES1_CHANNEL
            )}`,
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              CIRCLESLARPU
            )}`
          ]
        }
      ]
    }
  }
};

const flattenData = data => flattenObject(data, "", "->");
